import EmailSearch from '../Email/search.js'

export default class {

    out

    constructor(data) {
        console.log('started emailsss',data)
        let x = new EmailSearch({
            query: data.data.query,
            searchOnLoad: true
        })
        // content.append(x.html)

        this.out = x.html
        CS.Subsheet.body = x.html
        // CS.Subsheet.title = x.query


        return this

    }

    get body(){
        return this.out
    }

    get save(){
        return false;
    }
    get saveData(){
        return CS.collectData().rowData[0]
    }
}
